import dayjs from 'dayjs';
import { BaseElement, BaseElementProps } from '../base';
import { Omit } from '@vindr/utils/helpers/common.helper';

export interface DatetimeElementProps extends BaseElementProps {
  default_date: string; //? Only show when edited
  default_time: string; //? Only show when edited
  default_value: string;
  label: string;
  is_show_label: boolean;
  placeholder: string;
  format: string;
}

class DateTimeElement extends BaseElement {
  public default_value: string;
  public label: string;
  public is_show_label: boolean;
  public placeholder: string;
  public format = 'DD/MM/YYYY HH:mm:ss';
  default_date: string;
  default_time: string;

  constructor(props: DatetimeElementProps) {
    super(props);
    const { default_value, label, is_show_label, placeholder, format } = props;

    this.default_value = default_value || props.default_value;
    this.label = label;
    this.is_show_label = is_show_label;
    this.placeholder = placeholder;
    this.format = format || props.default_value;
    this.default_date = props?.default_date || props?.metadata?.default_date;
    this.default_time = props?.default_time || props?.metadata?.default_time;
  }

  public setValue(value: string) {
    this.value = value;
  }

  public render(): string {
    if (this.is_hidden) return '';
    const formatValue = this.value ? dayjs(this.value).format(this.format) : '';
    return `<span data-name="${this.name}" ${
      this.highlight ? 'style="background-color: yellow;"' : ''
    }>${this.is_show_label ? this.label + formatValue : formatValue}</span>`;
  }

  toJSON() {
    return Omit(this, ['parent', 'highlight']);
  }
}

export default DateTimeElement;
